import "./index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { ReposProvider } from "@/components/providers/repos-provider.tsx";
import { ThemeProvider } from "@/components/providers/theme-provider.tsx";
import { router } from "@/routes.ts";

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <ReposProvider>
            <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
                <RouterProvider router={router} />
            </ThemeProvider>
        </ReposProvider>
    </StrictMode>,
);
